import { Outlet, Route } from 'react-router'
import { type FC } from 'react'
import { useTranslation } from '@egw/i18n'
import { IdleTimerEnrollment } from '@egw/features-auth'
import { WEALTH_ROUTES } from '@egw/constants'
import { useSubmitEnrollmentAbandonApplicationData } from '@egw/api'
import { ROUTES } from '../../constants/routes/routes-joint'
import { ALL_ENROLLMENT_ROUTES } from '../../constants'
import { HomePage } from './home'
import { SelectAccountPage } from './select-account'
import { AccountTypePage } from './account-type'
import { ContactInfoPage } from './contact-info'
import { HomeAddressPage } from './home-address'
import { VerifyEmailPage } from './verify-email'
import { EmploymentPage } from './employment'
import { FinancesPage } from './finances'
import { InvestmentGoalsPage } from './investment-goals'
import { ConfirmInformationPage } from './confirm-information'
import { SuitabilityPage } from './suitability'
import { DisclosuresPage } from './disclosures'
import { VerifyPhonePage } from './verify-phone'
import { CreatePasskeyPage } from './create-passkey'
import { WelcomePage } from './welcome'
import { ManualReviewPage } from './manual-review'
import { NextStepDisclosuresPage } from './next-step-disclosures'
import { VerifyIdentityPage } from './verify-identity'
import { ReenterVerifyPhonePage } from './reenter-verify-phone'
import { DocumentVerificationPage } from './document-verification'
import { DocumentVerificationCompletePage } from './document-verification-complete'
import { DeclineExperiment, DeclinePage } from '../generic/decline'
//INTEGRATION:EnrolmentImports

/**
 * Enrollment Joint level components that are not tied to a specific route, such as IDLE modal
 */
const AppComponents: FC = () => {
  const { t } = useTranslation('features-enrollment')
  const { mutate } = useSubmitEnrollmentAbandonApplicationData()

  const signOutRoute = `${WEALTH_ROUTES.ENROLLMENT.path}/${ALL_ENROLLMENT_ROUTES.GENERIC.ROUTES.TIMED_OUT.path}`

  return (
    <IdleTimerEnrollment
      title={t('common.idle_unauthenticated.session_expired')}
      message={t('common.idle_unauthenticated.session_timeout_description')}
      signOutRoute={signOutRoute}
      onSignOut={() => {
        mutate({
          abandonApplication: true,
        })
      }}
    />
  )
}

export const routerJoint = (): JSX.Element | null => {
  return (
    <Route
      key="location-manager"
      path=""
      element={
        <>
          {/* Add custom LocationManager component here to add any redirect logic */}
          <AppComponents />
          <Outlet />
        </>
      }
    >
      {/* INTEGRATION:EnrollmentRoute */}
      <Route path={ROUTES.DOCUMENT_VERIFICATION_COMPLETE.path} element={<DocumentVerificationCompletePage />} />
      <Route path={ROUTES.DOCUMENT_VERIFICATION.path} element={<DocumentVerificationPage />} />
      <Route path={ROUTES.REENTER_VERIFY_PHONE.path} element={<ReenterVerifyPhonePage />} />
      <Route path={ROUTES.VERIFY_IDENTITY.path} element={<VerifyIdentityPage />} />
      <Route path={ROUTES.NEXT_STEP_DISCLOSURES.path} element={<NextStepDisclosuresPage />} />
      <Route path={ROUTES.MANUAL_REVIEW.path} element={<ManualReviewPage />} />
      <Route path={ROUTES.CREATE_PASSKEY.path} element={<CreatePasskeyPage />} />
      <Route path={ROUTES.WELCOME.path} element={<WelcomePage variant="both-accepted-disclosures" />} />
      <Route path={ROUTES.WELCOME_V2.path} element={<WelcomePage variant="one-accepted-disclosures" />} />
      <Route path={ROUTES.VERIFY_PHONE.path} element={<VerifyPhonePage />} />
      <Route path={ROUTES.SUITABILITY.path} element={<SuitabilityPage />} />
      <Route path={ROUTES.DISCLOSURES.path} element={<DisclosuresPage />} />
      <Route path={ROUTES.INVESTMENT_GOALS.path} element={<InvestmentGoalsPage />} />
      <Route path={ROUTES.EMPLOYMENT.path} element={<EmploymentPage />} />
      <Route path={ROUTES.CONFIRM_INFORMATION.path} element={<ConfirmInformationPage />} />
      <Route path={ROUTES.FINANCES.path} element={<FinancesPage />} />
      <Route path={ROUTES.HOME_ADDRESS.path} element={<HomeAddressPage />} />
      <Route path={ROUTES.ACCOUNT_TYPE.path} element={<AccountTypePage />} />
      <Route path={ROUTES.VERIFY_EMAIL.path} element={<VerifyEmailPage />} />
      <Route path={ROUTES.SELECT_ACCOUNT.path} element={<SelectAccountPage />} />
      <Route path={ROUTES.CONTACT_INFO.path} element={<ContactInfoPage />} />
      <Route path={ROUTES.JOINT_HOME.path} element={<HomePage />} />
      <Route path={ROUTES.DECLINE.path} element={<DeclinePage experiment={DeclineExperiment.Joint} />} />
    </Route>
  )
}
